export const interpolate = (str: string, variables: object) => str.replace(/\$\{[^}]+\}/g, (match) => (variables as any)[match.slice(2, -1)]);

export const parseParams = (url: string) => {
  const queryParamsHash: any = {};
  if (url && url !== '') {
    url
      .trim()
      .replace(/^\?/, '')
      .split('&')
      .forEach((paramPair) => {
        const kv = paramPair.split('=').map((i) => decodeURIComponent(i).trim());
        if (!queryParamsHash[kv[0]]) {
          queryParamsHash[kv[0]] = kv[1];
        }
      });
  }
  return queryParamsHash;
};

export const isEmail = (email: string) => {
  // tslint:disable:max-line-length
  return /[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/.test(
    email,
  );
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function concatenateName(...names) {
  return names.filter(Boolean).join(' '); // returns empty string when array is empty
}
